"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMouseEventData = exports.getMouseEventName = exports.isMeta = void 0;
/** Checks if a MouseEvent is opening a new tab */
function isMeta(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
exports.isMeta = isMeta;
/** Returns the event name associated with an element or name of the event there isn't any */
function getMouseEventName(event) {
    const el = event.currentTarget;
    const dataset = el.dataset || {};
    return dataset.event || event.type.toLowerCase();
}
exports.getMouseEventName = getMouseEventName;
/** Returns all data associated with an element  */
function getMouseEventData(event) {
    const el = event.currentTarget;
    const target = el.target || undefined;
    const dataset = el.dataset || {};
    const data = {
        location: location.toString(),
        text: el.innerText.trim() || el.title.trim(),
        rel: el.rel || undefined,
        target,
        href: el.getAttribute('href') ||
            el.getAttributeNS('http://www.w3.org/1999/xlink', 'href') ||
            el.getAttribute('xlink:href') ||
            undefined,
    };
    return { ...dataset, ...data };
}
exports.getMouseEventData = getMouseEventData;
